<script>
import Storage from "@/libs/Storage";
import Toast from "@/components/Toast.vue";
import {flagStoreStepToasts} from "@/libs/Helpers";

export default {
  name: "ToastTip",
  emits: ["onToastClose", "onToastAccept"],
  components: {Toast},
  props: {
    propToastId: String,
    propToastPosition: {type: String, default: "bottom"},
    propToastTrigger: Boolean,
    propToastDelay: {type: Number, default: 10000},

    propTitle: {type: String, default: null},
    propStorageFlag: {type: String, default: null}, //Key name in which store the action "Do not show again"
  },
  watch: {
    propToastTrigger(newValue, oldValue) {
      if (newValue === true) {
        this.setCloseInterval();
      }
    }
  },
  data() {
    return {
      availableTime: this.propToastDelay / 1000,
      availableIntervals: [],
      timeoutFunc: null
    }
  },
  methods: {
    setCloseInterval() {
      this.clearIntervals();

      let maxInterval = this.availableTime;
      for (let i = 1; i < maxInterval; i++) {
        this.availableIntervals.push(setTimeout(() => {
          this.availableTime -= 1;
        }, 1000 * i));
      }
    },
    clearIntervals() {
      this.availableIntervals.forEach((value) => {
        clearTimeout(value);
      });
      this.availableIntervals = [];
      this.availableTime = this.propToastDelay / 1000;
    },
    onToastMouseOver(e) {
      this.clearIntervals();
    },
    onToastMouseOut(e) {
      this.setCloseInterval();
    },
    onToastClose() {
      this.$emit("onToastClose");
    },
    onToastAccept() {
      if (flagStoreStepToasts() === true && this.propStorageFlag !== null) {
        let flagValue = Storage.get(this.propStorageFlag);
        if (flagValue !== true)
          Storage.set(this.propStorageFlag, true);
      }
      this.$emit("onToastAccept");
    }
  }
}
</script>

<template>
  <!-- Tutorial: step for simulation results -->
  <Toast :prop-id="propToastId"
         prop-border-class="dark"
         :prop-position="propToastPosition"
         :prop-auto-hide="true"
         :prop-delay="propToastDelay"
         :prop-show-close="false"
         :prop-trigger="propToastTrigger"
         @on-toast-mouse-over="onToastMouseOver"
         @on-toast-mouse-out="onToastMouseOut"
         @on-toast-close="onToastClose">
    <template v-slot:header v-if="propTitle !== '' && propTitle !== null">
      <span class="h5 text-success me-auto my-0">
        <i class="bi bi-lightbulb me-2"/>
        <span>{{ propTitle }}</span>
      </span>
      <span class="badge rounded-pill text-bg-purple-strong mt-1">{{ $t('layerInfo.closesIn') }} {{
          availableTime
        }}s</span>
    </template>
    <template v-slot:body>
      <slot></slot>
    </template>
    <template v-slot:actions>
      <hr class="my-3 text-black-50">
      <div class="d-flex justify-content-end gap-1">
        <button class="btn btn-warning btn-sm" @click="onToastAccept">
          <i class="bi bi-bell-slash-fill me-1"></i>
          <span>{{ $t('Actions.GotIt') }}</span>
        </button>
        <button class="btn btn-secondary btn-sm" @click="onToastClose">
          <i class="bi bi-x-lg me-1"></i>
          <span>{{ $t('buttons.close') }}</span>
        </button>
      </div>
    </template>
  </Toast>
</template>